/**
 * @generated SignedSource<<57976ee802c4d32608c4b75143bc07d7>>
 * @relayHash 377069177c915e79fa12abe05d4c74e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a153edf6cb8beecd6f73d82bc8ef1271e2a446848299a123e38b55115772448c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessAttachmentsQuery } from './src_jiraBusinessAttachmentsQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessAttachmentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a153edf6cb8beecd6f73d82bc8ef1271e2a446848299a123e38b55115772448c",
    "metadata": {},
    "name": "src_jiraBusinessAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
